import { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../components/common/secondary header/index";
import OverallReport from "./overall-report";
import SubTopicWiseReport from "./sub-topic-report";
import Main from "../../../layout/main";
import "./style.scss";
import { TEACHER } from "../../../constants";
import { subtopicReportReset } from "../../../store/actions";
import CustomSkillTable from './CustomSkillTable/index';
import CustomPaginatedTable from './CustomPaginatedTable/index';
import { ArrowBack } from "../../../static/img/images";
import { getQueryStringParams } from "../../../helpers";
import { textIdentifier } from "../../../textIdentifier";

export default function ReportByClass() {
  const [activeTab, setActiveTab] = useState(0);
  const userType = useSelector((state) => state.auth.userType);
  const dispatch = useDispatch();
  const { selectedCompetition, selectedSchool, selectedClass, classSubtopicOverallReportdata, activeTopic, classSubtopicSkillReportdata,lang } = useSelector(
    (state) => state.main
  );

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!selectedCompetition || !selectedSchool || !selectedClass) {
      navigate("/dashboard");
    }
    let qParams = getQueryStringParams(location.search);
    if(!!qParams.student&&!!qParams.classCode){
      navigate(`/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes/${selectedClass.id}/students?student=${qParams.student}&classCode=${qParams.classCode}`)
    }
  }, []);

  const renderCardJSX = () => {
    switch (activeTab) {
      case 1:
        return <SubTopicWiseReport />;
      default:
        return <OverallReport />;
    }
  };

  const handleTabChange = () => setActiveTab((pre) => (pre === 0 ? 1 : 0));

  if (!selectedCompetition || !selectedSchool || !selectedClass) {
    return null;
  }

  return (
    <Fragment>
      <Header
        title={selectedCompetition.name}
        navigateBackto={userType === TEACHER ? "/dashboard#report" : -1}
      />

      <Main className="report-school-classes">
        {/* heading card */}
        <div className="card heading-card">
          <div className="card-body">
            <span className="card-title">
              <span
                onClick={() => {
                  navigate(
                    `/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes`
                  );
                }}
              >
                {selectedSchool.name}
              </span>{" "}
              / {selectedClass.name}{" "}
              <span className="text-primary">({textIdentifier["rank"][lang]} {selectedClass.rank})</span>
            </span>

            <Link
              to={`/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes/${selectedClass.id}/students`}
            >
              <button className={"btn-contained"}>{textIdentifier["students"][lang]}</button>
            </Link>
          </div>
        </div>

        {/* heading card */}

        {/* content */}
        {
          classSubtopicOverallReportdata!=undefined?
          <div className="cr-wrapper-card">
          <button onClick={()=>{dispatch(subtopicReportReset())}} className="cr-back-btn"><ArrowBack/> {textIdentifier["back"][lang]}</button>
            <div className="cr-card sub-topic-wise-report">
              <CustomPaginatedTable activeTopic={!!activeTopic && activeTopic} data={!!classSubtopicOverallReportdata && classSubtopicOverallReportdata} />
            </div>
          </div>
          :
          classSubtopicSkillReportdata!=undefined?
          <div className="cr-wrapper-card">
          <button onClick={()=>{dispatch(subtopicReportReset())}} className="cr-back-btn"><ArrowBack/> {textIdentifier["back"][lang]} </button>
            <div className="cr-card sub-topic-wise-report">
              <CustomSkillTable activeTopic={!!activeTopic && activeTopic} data={!!classSubtopicSkillReportdata && classSubtopicSkillReportdata} />
            </div>
          </div>
          :
        <div className="cr-wrapper-card">
          <div className="cr-card-header">
            <button
              onClick={handleTabChange}
              className={
                activeTab === 0
                  ? "btn-contained bg-primary"
                  : "btn-outlined bg-transparent"
              }
            >
              {textIdentifier["overall-report"][lang]}
            </button>
            <button
              onClick={handleTabChange}
              className={
                activeTab === 1
                  ? "btn-contained bg-primary"
                  : "btn-outlined bg-transparent"
              }
            >
              {textIdentifier["subtopic-wise-report"][lang]}
            </button>
          </div>

          {renderCardJSX()}
        </div>
        }
      </Main>
    </Fragment>
  );
}
